import { createContext } from "react";
const speechContext=createContext();
export default speechContext;